import { StoreRootModule } from '@ngrx/store';
import { ModuleWithProviders } from '@angular/core';
import { NgRxUtil } from './ngrx-util';

export class StoreModuleTestUtil {
  public static getStoreModuleForRootWithDefaultNgRx(): ModuleWithProviders<StoreRootModule> {
    return NgRxUtil.getStoreModuleForRootWithDefaultNgRxRuntimeChecks();
  }
}
